<template>
  <div data-app>
    <v-container>
      <h1>{{ title }}</h1>
      <v-data-table :items="items" :headers="headers">
        <template v-slot:item.actions="{ item }">
          <v-btn
            icon
            text
            :to="
              `/onboarding-plan-setup-app/${item.transactionNo}?order=${item.order}`
            "
          >
            <v-icon>mdi-arrow-right-bold</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>
<script>
import { headers } from "./variable";
export default {
  metaInfo: {
    title: "Onboarding Plan Setup Approval",
    titleTemplate: `%s`,
  },
  data: () => ({
    title: "Onboarding Plan Setup Approval",
    items: [],
    headers: [
      {
        text: "",
        value: "actions",
        sortable: false,
      },
      {
        text: "Transaction No.",
        value: "transactionNo",
        sortable: false,
      },
      {
        text: "Order",
        value: "order",
        sortable: false,
      },
      {
        text: "Status",
        value: "status",
        sortable: false,
      },
    ],
  }),
  methods: {
    getForApproval() {
      this.$axios
        .get(`/api/onboarding/setup/approval`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    goTo(item) {
      this.$router.push(
        `/onboarding-plan-setup-app/${item.transactionNo}?order=${item.order}`
      );
    },
  },
  created() {
    this.getForApproval();
  },
};
</script>
